const RELOADED_AT_KEY = 'ca-chunk-reload-at';
const RETRY_WINDOW_MS = 10_000;

/**
 * After a deploy, a tab opened on the previous version asks for chunk files that no longer exist (Cloudflare answers
 * with index.html), so a lazy page fails to load. Reload once to pick up the new build; if the reload itself still
 * fails within a few seconds, let the error surface instead of looping.
 */
export function installChunkReloadGuard(): void {
  window.addEventListener('vite:preloadError', (event) => {
    const last = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
    if (Date.now() - last < RETRY_WINDOW_MS) return;
    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  });
}
